/**
 * 字級（小 / 中 / 大）。中＝標準字（不掛屬性），小＝data-textsize="sm"，大＝data-textsize="lg"。
 *
 * 不是把整頁 zoom 放大 —— 舊系統的「大」字級是對 <main>
 * 下 zoom，結果代碼、日期、說明這些寫死 px 的地方跟著糊掉或根本沒變大，
 * 也把版面算歪（zoom 會影響 position:fixed 與捲動座標）。
 *
 * 現在改成只切一個 data-textsize 屬性，bundle.css 裡的 --t-* 整組換值，
 * 連 .el-code、.el-meta 都會跟著放大，版面則由 CSS 自己重排
 * （清單列改成上下兩行、兩欄併成一欄），不會被擠破。
 *
 * 掛在 <html> 而不是設計稿範本的 #app：對話框、Toast、右側面板都是
 * 直接掛在 body 下的浮層，掛在 #app 上它們會吃不到。
 */

const KEY = "TEXT_SIZE";

/** 舊的 FONT_SCALE（sm / md / lg + zoom）—— 沒選過新字級的人沿用它 */
const LEGACY_KEY = "FONT_SCALE";

/** 可用的值："sm"（小）、""（中，標準）、"lg"（大） */
const norm = (v) => (v === "sm" || v === "lg" ? v : "");

export function getTextSize() {
  const saved = localStorage.getItem(KEY);
  if (saved !== null) return norm(saved);
  // 還沒選過：沿用舊的 FONT_SCALE，原本選「小」或「大」的人升級後仍然是同一段
  return norm(localStorage.getItem(LEGACY_KEY));
}

export function applyTextSize(size) {
  const el = document.documentElement;
  const v = norm(size);
  if (v) el.setAttribute("data-textsize", v);
  else el.removeAttribute("data-textsize");
}

export function setTextSize(size) {
  const next = norm(size);
  localStorage.setItem(KEY, next);
  applyTextSize(next);
  return next;
}

/** 字級的三個選項（切換鈕共用）。preview 是按鈕本身的字級，讓人一眼看出大小差別 */
export const TEXT_SIZES = [
  { value: "sm", label: "小", preview: "15px" },
  { value: "", label: "中", preview: "17px" },
  { value: "lg", label: "大", preview: "21px" },
];

export function initTextSize() {
  applyTextSize(getTextSize());
}
